import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import { tokens } from "../../theme";

const colors = tokens();

const styles = StyleSheet.create({
  wrapper: {
    width: "100%",
    marginTop: -30,   
    marginBottom: 14,
  },

  content: {
    paddingHorizontal: 0,
    paddingTop: 0,
  },

  title: {
    fontSize: 22,
    fontWeight: "bold",
    marginBottom: 2,
    color: colors.primary[100],
  },

  subtitle: {
    fontSize: 15,
    color: colors.green[200],
    marginBottom: 10,
  },

  divider: {
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.grey[300],
  },
});

export default function ReportHeader({ title, subtitle }) {
  return (
    <View style={styles.wrapper}>
      <View style={styles.content}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.subtitle}>{subtitle}</Text>
      </View>
      <View style={styles.divider} />
    </View>
  );
}